export const SUPPORTED_LOCALES = ['en', 'zh', 'zh-TW', 'ja', 'ko', 'es', 'pt', 'fr', 'de'];
export const DEFAULT_LOCALE = 'en';
